import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState, AppDispatch } from '../../app/store';
import { logout, setActiveEmployerCode } from '../../app/slice/authSlice';

export interface IEmployer {
  id?: string;
  name: string;
  description?: string;
  employerCode: string;
  emailAddress: string;
  includeInScheduleNotification?: boolean;
  users?: {
    userId: string;
    emailAddress: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    roles: string[];
  }[];
}

interface EmployerState {
  employer: IEmployer | null;
}

const initialState: EmployerState = {
  employer: null,
};

export const employersSlice = createSlice({
  name: 'employers',
  initialState,
  reducers: {
    selectEmployer: (state, action: PayloadAction<IEmployer | null>) => {
      state.employer = action.payload;
    },
    clearEmployer: (state) => {
      state.employer = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => ({ ...initialState }));
  },
});

export const { selectEmployer, clearEmployer } = employersSlice.actions;

export const handleSelectEmployer = (employer: any) => (dispatch: AppDispatch) => {
    if (!employer || !employer.id) {
        localStorage.removeItem('employer');
        localStorage.removeItem('employerCode');
        dispatch(selectEmployer(null));
        dispatch(setActiveEmployerCode(''));
        return;
    }

    localStorage.setItem('employer', JSON.stringify(employer));
    localStorage.setItem('employerCode', employer.employerCode || '');
    dispatch(selectEmployer(employer));
    dispatch(setActiveEmployerCode(employer.employerCode || ''));
}


// ── Selectors ─────────────────────────────────────────────────────────────────
export const selectSelectedEmployer = (state: RootState) => state.employers.employer;

export default employersSlice.reducer;
